import React, { Component } from "react";
import { Col, Row, Container, Card, Button } from "reactstrap";

import "react-datepicker/dist/react-datepicker.css";
import RequestManager from "../../singletons/RequestManager";
import LoadingOverlay from "react-loading-overlay";
const requestManager = new RequestManager();

export default class DeliveryPersonScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      orderModalVisible: false,
      tempdpHubs: null,
      dpHubs: null,
    };
  }

  componentDidMount() {
    this.getUserProfile();
  }

  checkLoginMode = () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let loginMode = localStorage.getItem("loginMode");
    if (loginMode === "store") {
      console.log("storeInformation", JSON.stringify(storeInformation));
      let hubs = storeInformation.store.hubs.edges;
      let usersIds = [],
        dpHubs = [];
      for (let i = 0; i < hubs.length; i++) {
        for (
          let j = 0;
          j < hubs[i].node.hubDeliveryPersonRef.edges.length;
          j++
        ) {
          let hub = {
            huds_id: hubs[i].node.id,
            hubs_name: hubs[i].node.name,
            hubDeliveryPersonRefId:
              hubs[i].node.hubDeliveryPersonRef.edges[j].node.id,
            isApprove:
              hubs[i].node.hubDeliveryPersonRef.edges[j].node.isApprove,
            isMerchantSercurity:
              hubs[i].node.hubDeliveryPersonRef.edges[j].node
                .isMerchantSercurity,
            status: hubs[i].node.hubDeliveryPersonRef.edges[j].node.status,
            dpId:
              hubs[i].node.hubDeliveryPersonRef.edges[j].node.deliveryPerson.id,
            userId:
              hubs[i].node.hubDeliveryPersonRef.edges[j].node.deliveryPerson
                .user,
          };
          dpHubs.push(hub);
          usersIds.push(
            hubs[i].node.hubDeliveryPersonRef.edges[j].node.deliveryPerson.user
          );
        }
      }

      var uniqueArrayUserids = [];

      // Loop through array values
      // eslint-disable-next-line
      for (var value of usersIds) {
        if (uniqueArrayUserids.indexOf(value) === -1) {
          uniqueArrayUserids.push(value);
        }
      }
      if (uniqueArrayUserids.length > 0) {
        this.setState({
          tempdpHubs: dpHubs,
          storeInformation: storeInformation,
          usersIds: usersIds,
        });

        this.getUsersByIDs(uniqueArrayUserids);
      }
    }
  };

  getUsersByIDs = async (uniqueArrayUserids) => {
    let params = {
      forUsers: uniqueArrayUserids,
    };
    console.log("params", JSON.stringify(params));
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getUsersByIDs",
      params
    );
    console.log("getUsersByIDs", JSON.stringify(response));
    if (response.error) {
      // alert('Something went wrong. Please try again later.')
    } else {
      let res = response;
      console.log("getUsersByIDs", JSON.stringify(res.data.users.edges));
      let hubs = this.state.tempdpHubs;
      let temphubs = [];
      console.log("");
      for (let i = 0; i < hubs.length; i++) {
        for (let j = 0; j < res.data.users.edges.length; j++) {
          if (
            hubs[i].dpId ===
            res.data.users.edges[j].node.deliveryPersons.edges[0].node.id
          ) {
            let hub = {
              huds_id: hubs[i].huds_id,
              hubs_name: hubs[i].hubs_name,
              hubDeliveryPersonRefId: hubs[i].hubDeliveryPersonRefId,
              isApprove: hubs[i].isApprove,
              isMerchantSercurity: hubs[i].isMerchantSercurity,
              status: hubs[i].status,
              dpId: hubs[i].dpId,
              userId: hubs[i].userId,
              dpPhone: res.data.users.edges[j].node.phone,
              dpFirstName: res.data.users.edges[j].node.userProfile.firstName,
              dpLastName: res.data.users.edges[j].node.userProfile.lastName,
            };

            temphubs.push(hub);
          }
        }
      }
      this.setState({ dpHubs: temphubs });
      console.log("dpHubslen", JSON.stringify(temphubs.length));
      console.log("dpHubs", JSON.stringify(temphubs));
      //   if (res.data.userProfile.user.store === null) {
    }
  };

  toggleModal = () => {
    this.setState({
      orderModalVisible: !this.state.orderModalVisible,
    });
  };

  render() {
    const { spinnerLoading } = this.state;

    return (
      <LoadingOverlay
        style={{ width: "100%", height: "100%", zIndex: 999 }}
        active={spinnerLoading === true ? true : false}
        spinner
        text="Loading ..."
      >
        <Container fluid style={{ padding: 0, margin: 0 }}>
          <Row noGutters>
            <Col>
              <Card>
                <Container fluid>
                  <Row style={{ margin: 10 }}>
                    <Col
                      xs="12"
                      sm="12"
                      md="4"
                      lg="4"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <h5>{"Delivery persons"}</h5>
                    </Col>
                  </Row>
                  <Row noGutters>
                    <Col
                      sm="12"
                      md="3"
                      d="flex"
                      flex="column"
                      align-items="stretch"
                      style={{ backgroundColor: "whitesmoke" }}
                    >
                      {this.state.dpHubs &&
                        this.state.dpHubs.map((dp) => {
                          return (
                            <div>
                              <Card
                                className={"p-0"}
                                style={{
                                  display: "flex",
                                  margin: 10,
                                  color: "black",
                                }}
                              >
                                <p style={{ paddingLeft: 10 }}>
                                  {dp.dpFirstName + " " + dp.dpLastName}
                                </p>
                                <p style={{ paddingLeft: 10 }}>{dp.dpPhone}</p>
                                {dp.isApprove === true ||
                                dp.isMerchantSercurity === true ? (
                                  <p style={{ paddingLeft: 10 }}>
                                    {"Approved"}
                                  </p>
                                ) : (
                                  <p style={{ paddingLeft: 10 }}>
                                    {"Approve Pending"}
                                  </p>
                                )}
                                {dp.isApprove === true ? (
                                  <p style={{ paddingLeft: 10 }}>
                                    {"Delivery person"}
                                  </p>
                                ) : null}
                                {dp.isMerchantSercurity === true ? (
                                  <p style={{ paddingLeft: 10 }}>
                                    {"Merchant security"}
                                  </p>
                                ) : null}
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",

                                    padding: 10,
                                  }}
                                >
                                  {dp.isApprove === true ||
                                  dp.isMerchantSercurity === true ? (
                                    <Button
                                      style={{
                                        marginLeft: 10,
                                        backgroundColor: "red",
                                        color: "white",
                                      }}
                                      onClick={() => {
                                        this.updateDeliveryPersonHubRef(
                                          dp.hubDeliveryPersonRefId,
                                          "N",
                                          "INACTIVE"
                                        );
                                      }}
                                    >
                                      Delete
                                    </Button>
                                  ) : (
                                    <div>
                                      <Button
                                        style={{
                                          margin: 10,
                                          backgroundColor: "green",
                                          color: "white",
                                        }}
                                        onClick={() => {
                                          this.updateDeliveryPersonHubRef(
                                            dp.hubDeliveryPersonRefId,
                                            "DP",
                                            true
                                          );
                                        }}
                                      >
                                        Approve Delivery Boy
                                      </Button>

                                      <Button
                                        style={{
                                          margin: 10,
                                          backgroundColor: "green",
                                          color: "white",
                                        }}
                                        onClick={() => {
                                          this.updateDeliveryPersonHubRef(
                                            dp.hubDeliveryPersonRefId,
                                            "MS",
                                            true
                                          );
                                        }}
                                      >
                                        Approve Security
                                      </Button>
                                      <Button
                                        style={{
                                          margin: 10,
                                          backgroundColor: "red",
                                          color: "white",
                                        }}
                                        onClick={() => {
                                          this.updateDeliveryPersonHubRef(
                                            dp.hubDeliveryPersonRefId,
                                            "Delete",
                                            "INACTIVE"
                                          );
                                        }}
                                      >
                                        Delete
                                      </Button>
                                    </div>
                                  )}
                                </div>
                              </Card>
                            </div>
                          );
                        })}
                    </Col>
                  </Row>
                </Container>
              </Card>
            </Col>
          </Row>
        </Container>
      </LoadingOverlay>
    );
  }

  updateDeliveryPersonHubRef = async (id, isApprove, value) => {
    this.setState({ spinnerLoading: true });
    let requestManager = new RequestManager();
    let params;
    if (isApprove === "DP") {
      params = {
        input: {
          id: id,
          isApprove: value,
        },
      };
    } else if (isApprove === "MS") {
      params = {
        input: {
          id: id,
          isMerchantSercurity: value,
        },
      };
    } else {
      params = {
        input: {
          id: id,
          status: value,
        },
      };
    }
    console.log("params", JSON.stringify(params));
    let response = await requestManager.getResponseFromPredefinedQuery(
      "updateDeliveryPersonHubRef",
      params
    );

    if (response.error === null) {
      if (isApprove === "Delete") {
        let hubs = this.state.dpHubs;
        let temphubs = [];
        for (let i = 0; i < hubs.length; i++) {
          if (hubs[i].hubDeliveryPersonRefId === id) {
          } else {
            let hub = {
              huds_id: hubs[i].huds_id,
              hubs_name: hubs[i].hubs_name,
              hubDeliveryPersonRefId: hubs[i].hubDeliveryPersonRefId,
              isApprove: hubs[i].isApprove,
              status: hubs[i].status,
              dpId: hubs[i].dpId,
              userId: hubs[i].userId,
              dpPhone: hubs[i].dpPhone,
              dpFirstName: hubs[i].dpFirstName,
              dpLastName: hubs[i].dpLastName,
            };

            temphubs.push(hub);
          }
        }
        this.setState({ dpHubs: temphubs });
        console.log("dpHubslen2", JSON.stringify(temphubs.length));
      } else {
        let hubs = this.state.dpHubs;
        let temphubs = [];
        for (let i = 0; i < hubs.length; i++) {
          if (hubs[i].hubDeliveryPersonRefId === id) {
            if (isApprove === "DP") {
              let hub = {
                huds_id: hubs[i].huds_id,
                hubs_name: hubs[i].hubs_name,
                hubDeliveryPersonRefId: hubs[i].hubDeliveryPersonRefId,
                isApprove: value,
                isMerchantSercurity: hubs[i].isMerchantSercurity,
                status: hubs[i].status,
                dpId: hubs[i].dpId,
                userId: hubs[i].userId,
                dpPhone: hubs[i].dpPhone,
                dpFirstName: hubs[i].dpFirstName,
                dpLastName: hubs[i].dpLastName,
              };

              temphubs.push(hub);
            } else {
              let hub = {
                huds_id: hubs[i].huds_id,
                hubs_name: hubs[i].hubs_name,
                hubDeliveryPersonRefId: hubs[i].hubDeliveryPersonRefId,
                isApprove: hubs[i].isApprove,
                isMerchantSercurity: value,
                status: hubs[i].status,
                dpId: hubs[i].dpId,
                userId: hubs[i].userId,
                dpPhone: hubs[i].dpPhone,
                dpFirstName: hubs[i].dpFirstName,
                dpLastName: hubs[i].dpLastName,
              };

              temphubs.push(hub);
            }
          } else {
            let hub = {
              huds_id: hubs[i].huds_id,
              hubs_name: hubs[i].hubs_name,
              hubDeliveryPersonRefId: hubs[i].hubDeliveryPersonRefId,
              isApprove: hubs[i].isApprove,
              isMerchantSercurity: hubs[i].isMerchantSercurity,
              status: hubs[i].status,
              dpId: hubs[i].dpId,
              userId: hubs[i].userId,
              dpPhone: hubs[i].dpPhone,
              dpFirstName: hubs[i].dpFirstName,
              dpLastName: hubs[i].dpLastName,
            };

            temphubs.push(hub);
          }
        }
        this.setState({ dpHubs: temphubs });
        console.log("dpHubslen3", JSON.stringify(temphubs.length));
      }
      this.setState({ spinnerLoading: false });
    } else {
      this.setState({ spinnerLoading: false });
      alert(
        "Unable to update Store Status. Please check your internet connection."
      );
    }
  };

  getUserProfile = async () => {
    let params = {};
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getUserProfile",
      params
    );
    // console.log("getUserProfile", JSON.stringify(response));
    if (response.error) {
      // alert('Something went wrong. Please try again later.')
    } else {
      let res = response;
      if (res.data.userProfile.user.store === null) {
      } else {
        let loginMode = localStorage.getItem("loginMode");
        let storeInformation = JSON.parse(
          localStorage.getItem("storeInformation")
        );

        if (loginMode === "store") {
          let storeInfo = {
            user: storeInformation.user,
            store: res.data.userProfile.user.store,
            merchant: res.data.userProfile.user.merchant,
            concessionaire: res.data.userProfile.user.concessionaire,
            token: storeInformation.token,
          };

          localStorage.setItem("storeInformation", JSON.stringify(storeInfo));
          this.checkLoginMode();
        }
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/pages/DeliveryPersonScreen/DeliveryPersonScreen.js